import { Button, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import PasscodeInput from "../../../../../components/passcodeInput/PasscodeInput"
import useMultiInputFocus from "../../../../../hooks/useMultiInputFocus"
import { ParentPasscodeStep } from "../../../../../types"
import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"

const SetPasscode = () => {
  const { passcode, setPasscode, setStep } = useParentPasscodeModalStore()
  const { ref: passcodeInputRef } = useMultiInputFocus({ useEffectDelay: 200 })
  const { t } = useTranslation()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setStep(ParentPasscodeStep.CONFIRM_SET_PASSCODE)
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Typography variant="bodyBold">{t("PPC_SET_TITLE")}</Typography>
          <Typography variant="bodySmall">
            {t("PPC_CHANGE_LATER_DESC")}
          </Typography>
        </div>

        <PasscodeInput
          value={passcode}
          setValue={setPasscode}
          ref={passcodeInputRef}
        />

        <Button
          type="submit"
          text={t("PPC_NEXT")}
          fullWidth
          disabled={passcode.length !== 4}
        />
      </div>
    </form>
  )
}

export default SetPasscode
